export type AuthType = 0 | 1 | 2 | 3 | 4;

export const AuthType = {
  Custom: 0 as const,
  Webhook: 1 as const,
  Bearer: 2 as const,
  ApiKey: 3 as const,
  OAuth2: 4 as const,
};

export default AuthType;
